import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#d4af37',
      light: '#f1d77a',
      dark: '#a67c00',
      contrastText: '#1a0f08',
    },
    secondary: {
      main: '#f3cf6b',
    },
    background: {
      default: '#120205',
      paper: '#1a0505',
      paperGradient: 'linear-gradient(180deg, #050404 0%, #0c0303 100%)',
    },
    error: { main: '#ff453a' },
    warning: {
      main: '#d4af37',
      light: '#f1d77a',
      dark: '#a67c00',
    },
    success: { main: '#30d158' },
    text: {
      primary: '#f3dd9a',
      secondary: '#cfb875',
    },
  },
  shape: { borderRadius: 8 },
  typography: {
    fontFamily: '"Inter", "SF Pro Display", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    h4: { fontWeight: 700 },
    h5: { fontWeight: 700 },
    h6: { fontWeight: 700 },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: (theme) => ({
        body: {
          backgroundColor: theme.palette.background.default,
          backgroundImage: 'linear-gradient(155deg, #080505 0%, #0e0809 52%, #0f0304 100%)',
          backgroundAttachment: 'fixed',
          color: theme.palette.text.primary,
        },
      }),
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 600,
          textShadow: '0 0 12px rgba(212, 175, 55, 0.35)',
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 500,
          fontSize: '0.9rem',
          color: '#cfb875',
          '&.Mui-selected': {
            color: '#f1d77a',
            textShadow: '0 0 12px rgba(212, 175, 55, 0.45)',
          },
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        indicator: {
          backgroundColor: '#d4af37',
          boxShadow: '0 0 10px rgba(212, 175, 55, 0.6)',
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          textShadow: '0 0 8px rgba(212, 175, 55, 0.10)',
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: { fontWeight: 700, fontSize: '0.7rem' },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: ({ theme }) => ({
          backgroundColor: theme.palette.background.paper,
          backgroundImage: 'linear-gradient(0deg, #0d0d0d 0%, #0f0f0f 10%)',
        }),
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: ({ theme }) => ({
          backgroundColor: theme.palette.background.paper,
          backgroundImage: theme.palette.background.paperGradient,
        }),
      },
    },
  },
});

export default theme;
